import { IUserCompanyRoles } from "@redbelly-tokeniser/mystake-common-sdk";

export interface BusinessIdentityContext {
  companyId: string;
  userCompanyRoles: IUserCompanyRoles;
}

export const getBusinessIdentityContext = ({
  companyId,
  userCompanyRoles,
}: BusinessIdentityContext): BusinessIdentityContext => ({
  companyId,
  userCompanyRoles,
});
